export default {
    configuration: false,
    searchList: {
        searchTxt: [
            {
                name: '司机编号',
                value: 'driverCode',
                type: 'input',
                unfold: true,
                span: 3,
                multiple: false,
            },
            {
                name: '司机姓名',
                value: 'driverName',
                type: 'input',
                unfold: true,
                span: 3,
                multiple: false,
            },
            {
                name: '司机状态',
                value: 'driverStatus',
                type: 'select',
                unfold: true,
                span: 3,
                options: [
                    {
                        value: '0',
                        label: '启用',
                    },
                    {
                        value: '1',
                        label: '停用',
                    },
                ],
                multiple: false,
            },
            {
                name: '手机号',
                value: 'phoneNo',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '身份证号',
                value: 'idCard',
                type: 'input',
                unfold: true,
                span: 3,
            },
            {
                name: '复核状态',
                value: 'reviewStatusList',
                type: 'select',
                unfold: true,
                span: 3,
                multiple: true,
                optionNum: 'SRM_DRIVER_CAR_REVIEW_STATUS',
            },
        ],
        unfoldState: false,
        advancedBtn: true,
    },
    searchTotalTitle: [
        {
            name: '是否黑名单',
            value: 'blackFlag',
            type: 'select',
            unfold: true,
            span: 3,
            optionNum: 'SRM_BLACK_FLAG',
            multiple: false,
        },
        {
            name: '实名认证',
            value: 'authenticationFlag',
            type: 'select',
            unfold: true,
            span: 3,
            optionNum: 'SRM_BLACK_FLAG',
            multiple: false,
        },
    ],
    table: {
        switchType: true,
        tableCut: false,
        clickState: false,
        selectBtn: true,
        height: 300,
        columns: [
            {
                label: '供应商编码',
                prop: 'supplierCode',
                width: '120px',
            },
            {
                label: '司机编码',
                prop: 'driverCode',
                width: '150px',
            },
            {
                label: '状态',
                prop: 'driverStatus',
                width: '100px',
            },
            {
                label: '停用原因',
                prop: 'disableReason',
                width: '200px',
            },
            {
                label: '审批状态',
                prop: 'approvalStatus_',
                width: '100px',
            },
            {
                label: '复核状态',
                prop: 'reviewStatus_',
                width: '100px',
            },
            {
                label: '复核不通过原因',
                prop: 'reviewFailReason',
                width: '180px',
            },
            {
                label: '签署状态',
                prop: 'pushStatus',
                width: '100px',
                optionNum: 'SRM_SUPPLIER_DELEGATE_STATUS',
                type: 'select',
            },
            {
                label: '司机姓名',
                prop: 'driverName',
                width: '150px',
            },
            {
                label: '手机',
                prop: 'phoneNo_',
                width: '150px',
            },
            {
                label: '身份证号',
                prop: 'idCard_',
                width: '180px',
            },
            {
                label: '家庭地址',
                prop: 'familyAddress_',
                width: '250px',
            },
            {
                label: '身份证有效期',
                prop: 'idCardEndDate',
                width: '120px',
            },
            {
                label: '驾驶证号',
                prop: 'drivingLicence_',
                width: '200px',
            },
            {
                label: '驾驶证有效期',
                prop: 'driveEndDate',
                width: '200px',
            },
            {
                label: '是否黑名单',
                prop: 'blackFlag',
                width: '120px',
            },
            {
                label: '实名认证',
                prop: 'authenticationFlag',
                width: '120px',
            },
            {
                label: '国家',
                prop: 'countryName',
                width: '80px',
            },
            {
                label: '省份',
                prop: 'provinceName',
                width: '100px',
            },
            {
                label: '城市',
                prop: 'cityName',
                width: '100px',
            },
        ],
        action: [
            {
                type: 'text',
                label: '查看附件',
                size: 'mini',
                event: 'attachment',
                ifHas: '08000305',
            },
            {
                type: 'text',
                label: '审批详情',
                size: 'mini',
                event: 'approve',
                ifHas: '08000306',
            },
            {
                type: 'text',
                label: '签署详情',
                size: 'mini',
                event: 'sign',
            },
        ],
        leftOperation: true,
        leftWidth: 250,
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
    },
}
